import SignUpContext from '@activities/auth/SignUpActivity/context/SignUpContext';
import AuthApi from '@apis/auth/AuthApi';
import useIsEmailSignIn from '@hooks/auth/useIsEmailSignIn';
import useToast from '@hooks/ui/useToast';
import useProjectId from '@hooks/useProjectId';
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    code: string,
}

function useVerification({
    code,
}: Props) {
    const { t } = useTranslation('signUp');
    const { useValue, useVerified } = useContext(SignUpContext);
    const projectId = useProjectId();
    const [certValue] = useValue;
    const [_, setIsVerified] = useVerified;
    const toast = useToast();
    const isEmail = useIsEmailSignIn();
    const { mutate } = useMutation({
        mutationKey: ['verifySms', certValue, code, projectId],
        mutationFn: () => {
            if (isEmail) {
                return AuthApi.verifyEmail({
                    email: certValue,
                    authNo: code,
                    projectId,
                });
            }
            return AuthApi.verifySms({
                phoneNo: certValue,
                smsAuthNo: code,
                projectId,
            });
        },
        onSuccess() {
            setIsVerified(true);
            toast.success(t('toast.verificationComplete'));
        },
        onError() {
            toast.error(t('toast.verificationFailed'));
        },
    });
    return () => {
        if (certValue) {
            mutate();
        }
    };
}

export default useVerification;
